import {
    EDIT_ITEM_QUANTITY,
    SELECT_MULTIPLE_CHOICE,
    UPDATE_TOTALS,
    ADD_MULTIPLE_CUSTOMER_IDS,
    TOGGLE_OPTIONAL_ITEM,
    CLEAR_CUSTOMER_DATA,
    EDIT_CUSTOMER_ID_SELECTION,
    REMOVE_MULTIPLE_CUSTOMER_IDS,
    CLEAR_STATE,
    SET_PAYMENT_TYPE,
    SET_PAYMENT_NOTE,
    SET_USE_CARD_ON_FILE,
    EDIT_SELECTED_QUANTITY, SET_IGNORE_PAYMENT_STEP,
} from "./selectionActionTypes"

export function editCustomerIdSelection(id: string) {
    return {
        type: EDIT_CUSTOMER_ID_SELECTION,
        payload: {
            id: id,
        }
    }
}

export function addMultipleCustomerIdsSelection(ids: string[]) {
    return {
        type: ADD_MULTIPLE_CUSTOMER_IDS,
        payload: {
            ids: ids,
        }
    }
}

export function removeMultipleCustomerIdsSelection(ids: string[]) {
    return {
        type: REMOVE_MULTIPLE_CUSTOMER_IDS,
        payload: {
            ids: ids,
        }
    }
}

export function clearCustomerSelection() {
    return {
        type: CLEAR_CUSTOMER_DATA,
    }
}

export function toggleOptionalItem(id: string) {
    return {
        type: TOGGLE_OPTIONAL_ITEM,
        payload: {
            id: id,
        }
    }
}

export function selectMultipleChoice(selectedId: string, idsFromGroup: string[]) {
    return {
        type: SELECT_MULTIPLE_CHOICE,
        payload: {
            id: selectedId,
            idsFromGroup: idsFromGroup,
        }
    }
}

export function editItemQuantity(id: string, measure: string) {
    return {
        type: EDIT_ITEM_QUANTITY,
        payload: {
            itemId: id,
            measure: measure
        }
    }
}

export function editSelectedQuantity(itemIds: string[], measure: string) {
    return {
        type: EDIT_SELECTED_QUANTITY,
        payload: {
            itemIds: itemIds,
            measure: measure
        }
    }
}


export function updateTotals(subtotal: number, total: number) {
    return {
        type: UPDATE_TOTALS,
        payload: {
            subtotal: subtotal,
            total: total,
        }
    }
}

export function setPaymentType(paymentType: string){
    return {
        type: SET_PAYMENT_TYPE,
        payload: {
            paymentType: paymentType
        }
    }
}

export function setPaymentNote(paymentNote: string){
    return {
        type: SET_PAYMENT_NOTE,
        payload: {
            paymentNote: paymentNote
        }
    }
}

export function setUseDefaultCardOnFile(useDefaultCardOnFile: boolean){
    return {
        type: SET_USE_CARD_ON_FILE,
        payload: {
            useDefaultCardOnFile: useDefaultCardOnFile
        }
    }
}

export function setIgnorePaymentStep(ignorePaymentStep: boolean) {
    return {
        type: SET_IGNORE_PAYMENT_STEP,
        payload: {
            ignorePaymentStep: ignorePaymentStep
        }
    }
}

export function clearState() {
    return {
        type: CLEAR_STATE,
        payload: {}
    }
}



// WEBPACK FOOTER //
// ./src/state/selection/selectionActions.ts